import { Box, BoxProps, Loader, Text } from '@jfs/ui-new'
import { isEmptyObject as isEmpty } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { FC, useEffect } from 'react'
import { Button } from '../../comps/Button'
import Footer from '../../comps/Footer'
import { useLazyApiData, useStores } from '../../data/store'
import { ChildWindow } from './ChildWindow'
export const PaymentType = {
  UPI: 'UPI',
  NETBANKING: 'NETBANKING',
  JIOMONEY: 'JIOMONEY',
}

export const PaymentProcessing: FC = () => {
  const { navigate } = useNavigation()
  const { confirmPayment, returnurl, payLoad, updateShowPopup } = useStores((root) => ({
    confirmPayment: root.confirmPaymentApi,
    returnurl: root.transaction.getMerchantRedirectingUrl(),
    payLoad: root?.transaction?.txnMeta?.payLoad ?? {},
    updateShowPopup: root.config.updateShowPopup,
  }))

  const navigation: any = useNavigation()
  const [confirmPaymentApi, { state: confirmPaymentState }] = useLazyApiData(confirmPayment)
  useEffect(() => {
    confirmPaymentApi()
  }, [confirmPaymentApi, navigate])

  useEffect(() => {
    if (confirmPaymentState === 'rejected') {
      // navigate(pages.payment, { showPopup: false })
      //window.open('', 'JioPay')?.close()
      updateShowPopup(false)
      window.currentChild?.close()
      navigation.goBack()
    }
  }, [confirmPaymentState, navigation, updateShowPopup])

  console.log('PaymentProcessing')
  return (
    <Box {...styles.container}>
      <ChildWindow hide={isEmpty(payLoad)} retUrl={returnurl} />
      <Loader testID="loaderTest" type={'small'} color={'DARK_GREY'} />
      <Box {...styles.loadingText}>
        <Text type="h2" title="Processing the payment please wait..." fontFamily="jioType-medium" />
      </Box>
      <BackToPayment hide={isEmpty(payLoad)} />
      <Footer isBottomAligned={true} />
    </Box>
  )
}

const BackToPayment = ({ hide }: { hide: boolean }) => {
  if (hide) {
    return null
  }
  const handlePayment = () => {
    if (window.currentChild) {
      window.currentChild?.focus()
    }
  }
  return (
    <Button testID="backToPaymentTest" type="primary" onPress={handlePayment}>
      <Text type="h2" color="WHITE" fontFamily="jioType-Medium" fontWeight="700" fontSize={13}>
        Go Back To Payment
      </Text>
    </Button>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  loadingText: {
    marginVertical: 8,
  } as BoxProps,
}
